import type { ReactNode } from "react";
import type { BlacklistItem } from "@repo/api/blacklist.type";

export type BlacklistSetListItemProps = {
  item: BlacklistItem;
  onPress?: () => void;
  onOwnerPress?: () => void;
  dateLabel: string;
  actions?: ReactNode;
  className?: string;
};

export function BlacklistSetListItem({
  item,
  onPress,
  onOwnerPress,
  dateLabel,
  actions,
  className,
}: BlacklistSetListItemProps) {
  return (
    <div
      className={`flex items-center gap-3 border-b border-default-100 py-3 last:border-b-0 ${className ?? ""}`}
    >
      <div className="min-w-0 flex-1 flex flex-col gap-1">
        <button
          type="button"
          className="text-left text-sm font-medium text-gray-900 truncate hover:text-primary"
          onClick={onPress}
          disabled={!onPress}
        >
          {item.name}
        </button>
        <button
          type="button"
          className="text-left text-xs text-gray-500 truncate hover:text-primary"
          onClick={onOwnerPress}
          disabled={!onOwnerPress}
        >
          维护者：{item.nickname}
        </button>
        <div className="flex flex-wrap gap-1 text-xs text-gray-400">
          <span>{item.user_count} 人</span>
          <span>{dateLabel}</span>
        </div>
      </div>
      {actions ? <div className="shrink-0 flex items-center gap-1">{actions}</div> : null}
    </div>
  );
}
